const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_4289",
  "data-name": "Group 4289",
  transform: "translate(-291.221 -1381.159)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_5640",
  "data-name": "Path 5640",
  d: "M291.861,1383.322a3.655,3.655,0,0,1,2.854-1.2c.916.141,1.565.824,3.942,4.483a36.342,36.342,0,0,0,3.4,4.93c2.281,2.556,3.473,2.627,4.078,2.541a2.889,2.889,0,0,0,1.5-.748",
  fill: "none",
  stroke: "#7f4829",
  strokeWidth: 1.88
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5641",
  "data-name": "Path 5641",
  d: "M294.211,1394.1c1.57-1.947,3.294-3.965,5.184-6.022,2-2.177,3.974-4.167,5.882-5.978",
  fill: "none",
  stroke: "#7f4829",
  strokeWidth: 1.567
}));
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.034,
    height: 13.878,
    viewBox: "0 0 17.034 13.878",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.5a755a41.svg";
export { ForwardRef as ReactComponent };